import { makeStyles } from '@material-ui/core';
import React from 'react';
const useCommonStyles = makeStyles((theme: any) => ({
    chip: {
        fontSize: 12,
        width: 'auto',
        color: ' #fff',
        border: '1px solid #fff',
        borderRadius: '8px',
        padding: '2px 12px',
        //margin: '0px 8px',
        textAlign: 'center',
        backgroundColor: 'black',
    },
    chipText: {
        fontSize: 12,
        color: 'inherit',
    },
    active: {
        backgroundColor: 'rgba(76, 175, 80, 0.16) !important',
        border: '1px solid #4caf50 !important',
        color: '#4caf50 !important',
    },
    activeTxt: {
        color: '#4caf50 !important',
    },
    activeFill: {
        backgroundColor: '#4caf50 !important',
        border: '1px solid #4caf50 !important',
        color: '#fff !important',
    },
    activeOutlined: {
        backgroundColor: '#fff !important',
        border: '1px solid #D6D6D6 !important',
        color: '#4caf50 !important',
    },
    pending: {
        backgroundColor: 'rgba(255, 152, 0, 0.16) !important',
        border: '1px solid #ff9800 !important',
        color: '#ff9800 !important',
    },
    pendingFill: {
        backgroundColor: '#ff9800 !important',
        border: '1px solid #ff9800 !important',
        color: '#fff !important',
    },
    pendingOutlined: {
        backgroundColor: '#fff !important',
        border: '1px solid #D6D6D6 !important',
        color: '#ff9800 !important',
    },
    reject: {
        backgroundColor: 'rgba(244, 67, 54, 0.16) !important',
        border: '1px solid #f44336 !important',
        color: '#f44336 !important',
    },
    inactive: {
        backgroundColor: 'rgba(63, 81, 181, 0.16) !important',
        border: '1px solid #3f51b5 !important',
        color: '#3f51b5 !important',
    },
    none: {
        backgroundColor: '#F4F4F4',
        border: '1px solid #686868',
        color: '#686868',
    },
    none2: {
        backgroundColor: 'rgba(55, 55, 78, 0.16)',
        border: '1px solid #37374E',
        color: '#37374E',
    },
    menu: {
        border: '1px solid #3f51b5',
        color: ' #3f51b5',
        borderRadius: 8,
        padding: '8px',
    },
    box: {
        border: '1px solid #43419E',
        color: '#43419E',
        //borderRadius: 8,
        marginRight: '12px',
        padding: '1px',
    },
    boldText: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: '#14112D',
        marginRight: '1.5rem',
    },
}));
export default useCommonStyles;
